<template>
    <div>
        <div v-for="header in headers" :key="header.title">
            <v-card-title>{{ header.title }}</v-card-title>
            <v-card-text class="body-1" v-if="header.body">{{
                header.body
            }}</v-card-text>
            <component
                v-if="header.comp"
                :is="header.comp.name"
                v-bind="{ ...header.comp.props }"
                :class="header.comp.classes"
            />
        </div>
        <v-card-title>Private Lesson FAQ:</v-card-title>
        <v-expansion-panels v-model="panels" class="soli-round" accordion>
            <v-expansion-panel v-for="FAQ in FAQS" :key="FAQ.question">
                <v-expansion-panel-header class="font-weight-bold">{{
                    FAQ.question
                }}</v-expansion-panel-header>
                <v-expansion-panel-content
                    ><div
                        v-if="FAQ.answer"
                        v-html="FAQ.answer"
                        class="body-1" />
                    <component
                        v-if="FAQ.comp"
                        :is="FAQ.comp.name"
                        v-bind="{ ...FAQ.comp.props }"
                        :class="FAQ.comp.classes"
                /></v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import IndentList from "./IndentList.vue";
import RenderList from "./RenderList.vue";

export default {
    components: {
        RenderList,
        IndentList,
    },
    props: {
        location: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            panels: null,
            locationPrices: [],
        };
    },
    computed: {
        headers() {
            return [
                {
                    comp: {
                        name: "SoliVideoPlayer",
                        classes: ["mx-4 my-2"],
                        props: {
                            src: "https://player.vimeo.com/video/444890970",
                        },
                    },
                },
                {
                    title: "Our Private Music Lessons",
                    body: `Experience Simply Delightful Music Lessons with Musicologie! We are a premier music education company for ages 6 months through adults. Our private music lessons are specifically designed to make learning and playing music fun for all ages, abilities and instruments.`,
                },
                {
                    title: "Our Approach to Music Lessons",
                    body: `At Musicologie we know that music lessons are one of the most impactful investments you can make in yourself or in your child. Learning music improves coordination, language, reading and math skills. It nurtures our emotional and cognitive health. Studying an instrument makes our brains bigger and reduces chances of hearing loss and dementia in adults. Plus, it’s fun! We are proud to have a holistic private lesson program that shares music and its benefits with students of all ages and abilities.`,
                    /*comp: {
                        name: "IndentList",
                        classes: ["px-5 pt-0"],
                        props: {
                            items: [
                                "For kids under 5, Musicologie Junior is the way to go",
                                "Piano or guitar students age 7 and up, Accelerated Lab is the best way to learn",
                                "If you want to meet friends and play rock shows at real venues, RockStars is the program for you",
                            ],
                        },
                    },*/
                },
                /*{
                    title: "Getting Started",
                    body: `The first lesson is called an assessment lesson. Don’t worry - it’s not a test! You'll come in, meet your teacher, talk about your goals, go through our policies and develop an individual curriculum. Every student does it regardless of age or ability. For very young students, an assessment is also a chance to see if they're ready for private lessons. The assessment is ${this.getPrice(
                        "Assessment"
                    )} at Musicologie ${
                        this.location.name
                    } and is backed by our Perfect Match Promise. We want you to LOVE your lessons or we’ll refund that assessment charge, no questions asked.`,
                },*/
            ];
        },
        FAQS() {
            return [
                {
                    question: `How do private lessons at Musicologie work?`,
                    answer: `Private Lessons are weekly one-on-one sessions with one of our Certified Teachers specifically matched to you or your student based on your experience and goals. We offer both in-person lessons at our studios and online lessons so you can learn from anywhere.
                            Our teachers are experts at introducing young students to music, coaching adults who are just getting started or even helping professionals hone their craft. We believe music is for everyone and YOU deserve a great teacher.
                            `,
                },
                {
                    question: `Who are private lessons best for?`,
                    answer: `Private lessons are for almost everyone! However, for kids under 5, students who want a rock performance focus, or piano, guitar, or drum students age 7+, check out these programs instead:`,
                    comp: {
                        name: "IndentList",
                        classes: ["px-2"],
                        props: {
                            items: [
                                `· Musicologie Junior is the way to go for kids under 5`,
                                `· Accelerated Lab is the best way to learn for piano, guitar and drum students ages 7+`,
                                `· RockStars is an awesome program if you want to meet friends and play rock and pop songs in a band, ages 7+.`,
                            ],
                        },
                    },
                },
                {
                    hidden: !this.location,
                    question: "How do I get started?",
                    answer: `The first lesson is called an assessment lesson. Don’t worry - it’s not a test! You'll come in, meet your teacher, talk about your goals, go through our policies and develop an individual curriculum. Every student does it regardless of age or ability. For very young students, an assessment is also a chance to see if they're ready for private lessons. The assessment is ${this.getPrice(
                        "Assessment"
                    )} at Musicologie ${
                        this.location?.name
                    } and is backed by our Perfect Match Promise. We want you to LOVE your lessons or we’ll refund that assessment charge, no questions asked.`,
                },
                {
                    hidden: !this.location,
                    question: `How much are lessons at Musicologie ${this.location?.name}?`,
                    answer: null,
                    comp: {
                        name: "RenderList",
                        classes: ["px-0 pt-0"],
                        props: {
                            items: this.locationPrices
                                .filter((e) =>
                                    e.access.includes("Weekly Lesson")
                                )
                                .map((e) => ({
                                    content: `${
                                        e.description
                                    } start at: ${this.formatUnitAmount(
                                        e.amount
                                    )}`,
                                })),
                        },
                    },
                },
                {
                    question: "What age do lessons start at?",
                    answer: `Generally, private lessons start as early as 4 years old depending on the student and instrument. For students younger than 4, or who need a little more time before they start private lessons, we have Musicologie Junior, our toddler group music experience. Regardless of age or experience, every student going into private lessons starts with an assessment lesson.`,
                    comp: {
                        name: "IndentList",
                        classes: ["px-2"],
                        props: {
                            items: [
                                "· Piano - 30 minute private lessons start as early as four years old. For ages 7+ we have Accelerated Piano Lab, which allows a student to move through their lesson books rapidly. Once a student is past lesson books and into repertoire books, they’ll go into 60 minute private lessons to really help develop and hone more advanced performance skills.",
                                "· Voice - 7 years old",
                                "· Guitar/Ukulele/Bass - 4 years old",
                                "· Drums - 4 years old",
                                "· Strings - 4 years old",
                                "· Woodwinds/Brass - 9 years old",
                            ],
                        },
                    },
                },
                {
                    question: "Do you do lessons for adults?",
                    answer: `Yes! We have many adult students so you’ll be in good company. Our teachers meet you where you are to help accomplish your goals quickly. We have concerts and events specifically for our adult students, so you can show off your new skills in a supportive environment.`,
                },
                {
                    question: "Can I do lessons every other week?",
                    answer: `Unfortunately we don't offer every-other-week lessons through the Lesson Membership. A 30 minute weekly lesson is really the minimum necessary to make progress, see value and have a great experience. However, if that consistent weekly lesson just doesn’t work for you, we do have drop-in lessons. You can buy a pack of six 30 minute or 60 minute lessons and schedule them at your convenience.`,
                },
                {
                    question: "Is there a sibling or family discount?",
                    answer: `Yes. There is a 3% discount off your entire invoice if more than one family member is taking lessons. The discount is applied automatically and you'll see it on your monthly invoice.`,
                },
                {
                    question:
                        "My work schedule changes each week so committing to a weekly time is difficult. What should I do?",
                    answer: `Our rescheduling policy is <i>very</i> flexible in the event of an occasional conflict with work, school, sports or a sick family member. All you need to do is log into your account at musicologie.com to cancel or change your lesson. When you cancel a lesson more than 24 hours in advance, it will stay on your account available to be rescheduled at any point in the future. You can schedule with any available Musicologie teacher, in-person or online.`,
                },
                {
                    question: "What’s the withdrawal policy?",
                    answer: `To withdraw from lessons and end automatic billing, all you need to do is fill out the quick form at https://musicologie.com/exit 30 days before your last lesson. Your withdrawal is not processed until you fill out that form. We require 30 days notice, which begins the day that form is received. Your final invoice will be prorated the last 30 days.`,
                },
                {
                    question: "What’s the single lesson cancellation policy?",
                    answer: `You can cancel or change your weekly lesson up to 24 hours before the lesson. If you cancel, that lesson stays on your account and you can reschedule it at any time in the future. Canceled lessons never expire as long as you’re a current student. You can reschedule with any teacher at any Musicologie location, in-person or online.`,
                },
                {
                    question: "How do I reschedule a lesson?",
                    answer: `Log into your account at Musicologie.com to view your schedule and select any lesson to cancel or change. You can cancel or change a private lesson up to 24 hours before the lesson.`,
                },
            ].filter((e) => !e.hidden);
        },
    },
    methods: {
        getPrice(product) {
            if (!this.locationPrices.length) return "(...loading)";
            return this.formatUnitAmount(
                this.locationPrices.find((e) => e.name == product).amount
            );
        },
        getLocationPricing() {
            if (!this.location) return;

            axios
                .get(route("stripe.locationPricing"), {
                    params: {
                        location_id: this.location.id,
                    },
                })
                .then((resp) => {
                    this.locationPrices = resp.data;
                });
        },
    },
    mounted() {
        this.getLocationPricing();
    },
};
</script>
